import React, { useContext, useState, useCallback, useEffect } from "react";

// NavBar
import NavBar from "../navBar/NavBar";
// CONTEXT
import { AllDataSchedules } from "../../../context/AllDataSchedules";
// COMPONENT
import ScheduleItemAdmin from "./ScheduleItemAdmin/ScheduleItemAdmin";
import FilterSchedules from "./filterSchedules/FilterSchedules";


export default function ShowAllSchedules() {
  const { loadedData } = useContext(AllDataSchedules);
  const [filterData, setFilterData] = useState([]);

  // Logger tous les schedules avec 0 personne enregistrée
  useEffect(() => {
    const emptySchedules = loadedData.filter(schedule => schedule.usersRegisted.length === 0);
    if (emptySchedules.length > 0) {
      emptySchedules.forEach(schedule => {
      });
    }
  }, [loadedData]);

  const handleFilterData = useCallback(
    (sortedSchedules) => {
      setFilterData(sortedSchedules);
    },
    [loadedData]
  );


  return (
    <div className="show-all-schedules-container">
      <NavBar toggleClassName={1} />
      <FilterSchedules
        handleFilterData={handleFilterData}
        loadedData={loadedData}
      />

      <div className="schedules-container" >
        {filterData?.map((schedule, index) => (
          <React.Fragment key={index}>
            <ScheduleItemAdmin schedule={schedule} />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}


